import React, { useState } from 'react';
import Sidebar from '../../components/navigation/Sidebar';
import QuickActions from '../../components/navigation/QuickActions';
import CalendarHeader from './components/CalendarHeader';
import FilterPanel from './components/FilterPanel';
import DayView from './components/DayView';
import WeekView from './components/WeekView';
import MonthView from './components/MonthView';
import AppointmentModal from './components/AppointmentModal';
import WaitlistPanel from './components/WaitlistPanel';
import MobileAppointmentList from './components/MobileAppointmentList';

const AppointmentScheduling = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [viewMode, setViewMode] = useState('week');
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('view');

  const [filters, setFilters] = useState({
    provider: '',
    location: '',
    appointmentType: '',
    searchQuery: '',
    showAvailableOnly: false,
    showCancelled: false,
    showWaitlist: false
  });

  const providers = [
  {
    value: 'dr-smith',
    label: 'Dr. Sarah Smith',
    id: 'dr-smith',
    name: 'Dr. Sarah Smith',
    specialty: 'Internal Medicine',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ed76a677-1763293873868.png",
    avatarAlt: 'Professional headshot of Dr. Sarah Smith, female physician with brown hair in white medical coat'
  },
  {
    value: 'dr-johnson',
    label: 'Dr. Michael Johnson',
    id: 'dr-johnson',
    name: 'Dr. Michael Johnson',
    specialty: 'Cardiology',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_14cb16477-1763300517838.png",
    avatarAlt: 'Professional headshot of Dr. Michael Johnson, male cardiologist with short dark hair in blue medical scrubs'
  },
  {
    value: 'dr-williams',
    label: 'Dr. Emily Williams',
    id: 'dr-williams',
    name: 'Dr. Emily Williams',
    specialty: 'Pediatrics',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ed76a677-1763293873868.png",
    avatarAlt: 'Professional headshot of Dr. Emily Williams, female pediatrician with blonde hair in white medical coat'
  }];


  const locations = [
  { value: 'main-clinic', label: 'Main Clinic - Downtown' },
  { value: 'north-branch', label: 'North Branch Medical Center' },
  { value: 'south-facility', label: 'South Healthcare Facility' }];


  const appointmentTypes = [
  { value: 'new-patient', label: 'New Patient Visit' },
  { value: 'follow-up', label: 'Follow-up Appointment' },
  { value: 'annual-physical', label: 'Annual Physical Exam' },
  { value: 'consultation', label: 'Specialist Consultation' },
  { value: 'procedure', label: 'Medical Procedure' },
  { value: 'telehealth', label: 'Telehealth Visit' }];


  const mockAppointments = [
  {
    id: 'apt-001',
    patientName: 'John Anderson',
    patientMRN: 'MRN-789456',
    patientAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc78c630-1763296946525.png",
    patientAvatarAlt: 'Professional photo of John Anderson, middle-aged man with gray hair wearing blue business shirt',
    providerId: 'dr-smith',
    providerName: 'Dr. Sarah Smith',
    type: 'Follow-up Appointment',
    startTime: new Date(2026, 0, 14, 9, 0),
    duration: 30,
    status: 'confirmed',
    notes: 'Blood pressure follow-up after medication adjustment',
    insuranceStatus: true
  },
  {
    id: 'apt-002',
    patientName: 'Maria Garcia',
    patientMRN: 'MRN-456123',
    patientAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10b547594-1763294201023.png",
    patientAvatarAlt: 'Professional photo of Maria Garcia, Hispanic woman with long dark hair wearing green blouse',
    providerId: 'dr-johnson',
    providerName: 'Dr. Michael Johnson',
    type: 'Specialist Consultation',
    startTime: new Date(2026, 0, 14, 10, 0),
    duration: 45,
    status: 'confirmed',
    notes: 'Cardiac evaluation for chest pain symptoms',
    insuranceStatus: true
  },
  {
    id: 'apt-003',
    patientName: 'David Chen',
    patientMRN: 'MRN-321654',
    patientAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ea3461a7-1763301220913.png",
    patientAvatarAlt: 'Professional photo of David Chen, Asian man with black hair wearing gray suit jacket',
    providerId: 'dr-smith',
    providerName: 'Dr. Sarah Smith',
    type: 'Annual Physical Exam',
    startTime: new Date(2026, 0, 14, 11, 0),
    duration: 60,
    status: 'pending',
    notes: 'Annual wellness visit with lab work',
    insuranceStatus: false
  },
  {
    id: 'apt-004',
    patientName: 'Sarah Thompson',
    patientMRN: 'MRN-987321',
    patientAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_15f94130f-1763296604240.png",
    patientAvatarAlt: 'Professional photo of Sarah Thompson, young woman with red hair wearing white blouse',
    providerId: 'dr-williams',
    providerName: 'Dr. Emily Williams',
    type: 'New Patient Visit',
    startTime: new Date(2026, 0, 14, 14, 0),
    duration: 45,
    status: 'confirmed',
    notes: 'New patient intake for pediatric care',
    insuranceStatus: true
  },
  {
    id: 'apt-005',
    patientName: 'Robert Martinez',
    patientMRN: 'MRN-654987',
    patientAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1157fa903-1763295558923.png",
    patientAvatarAlt: 'Professional photo of Robert Martinez, Hispanic man with mustache wearing blue polo shirt',
    providerId: 'dr-johnson',
    providerName: 'Dr. Michael Johnson',
    type: 'Follow-up Appointment',
    startTime: new Date(2026, 0, 15, 9, 30),
    duration: 30,
    status: 'confirmed',
    notes: 'Post-procedure follow-up',
    insuranceStatus: true
  },
  {
    id: 'apt-006',
    patientName: 'Lisa Brown',
    patientMRN: 'MRN-147258',
    patientAvatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b032f6ab-1763294605043.png",
    patientAvatarAlt: 'Professional photo of Lisa Brown, woman with short blonde hair wearing pink cardigan',
    providerId: 'dr-smith',
    providerName: 'Dr. Sarah Smith',
    type: 'Telehealth Visit',
    startTime: new Date(2026, 0, 15, 13, 0),
    duration: 30,
    status: 'pending',
    notes: 'Virtual consultation for medication review',
    insuranceStatus: true
  }];


  const waitlistPatients = [
  {
    id: 'wait-001',
    name: 'Jennifer Wilson',
    mrn: 'MRN-852963',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c56710a9-1763300346689.png",
    avatarAlt: 'Professional photo of Jennifer Wilson, woman with curly brown hair wearing yellow blouse',
    preferredDate: 'This Week',
    preferredProvider: 'Dr. Sarah Smith',
    appointmentType: 'Follow-up Appointment'
  },
  {
    id: 'wait-002',
    name: 'Michael Davis',
    mrn: 'MRN-741852',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1796e207f-1763296799306.png",
    avatarAlt: 'Professional photo of Michael Davis, man with beard wearing navy blue shirt',
    preferredDate: 'Next Week',
    preferredProvider: 'Dr. Michael Johnson',
    appointmentType: 'Specialist Consultation'
  }];


  const quickActions = [
  {
    id: 'new-appointment',
    label: 'New Appointment',
    icon: 'Plus',
    onClick: () => {
      setModalMode('create');
      setSelectedAppointment(null);
      setIsModalOpen(true);
    },
    shortcut: 'Ctrl+N'
  },
  {
    id: 'view-waitlist',
    label: 'View Waitlist',
    icon: 'Clock',
    onClick: () => {
      setFilters((prev) => ({ ...prev, showWaitlist: !prev?.showWaitlist }));
    },
    shortcut: 'Ctrl+W'
  },
  {
    id: 'print-schedule',
    label: 'Print Schedule',
    icon: 'Printer',
    onClick: () => console.log('Print schedule'),
    shortcut: 'Ctrl+P'
  },
  {
    id: 'export-calendar',
    label: 'Export Calendar',
    icon: 'Download',
    onClick: () => console.log('Export calendar'),
    shortcut: 'Ctrl+E'
  }];


  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleNavigate = (direction) => {
    const newDate = new Date(currentDate);
    if (viewMode === 'day') {
      newDate?.setDate(newDate?.getDate() + (direction === 'next' ? 1 : -1));
    } else if (viewMode === 'week') {
      newDate?.setDate(newDate?.getDate() + (direction === 'next' ? 7 : -7));
    } else {
      newDate?.setMonth(newDate?.getMonth() + (direction === 'next' ? 1 : -1));
    }
    setCurrentDate(newDate);
  };

  const handleTodayClick = () => {
    setCurrentDate(new Date());
  };

  const handleAppointmentClick = (appointment) => {
    setSelectedAppointment(appointment);
    setModalMode('view');
    setIsModalOpen(true);
  };

  const handleSlotClick = (providerId, hour) => {
    console.log('Slot clicked:', providerId, hour);
    setModalMode('create');
    setSelectedAppointment(null);
    setIsModalOpen(true);
  };

  const handleDateClick = (date) => {
    setCurrentDate(date);
    setViewMode('day');
  };

  const handleSaveAppointment = (appointmentData) => {
    console.log('Save appointment:', appointmentData);
    setIsModalOpen(false);
  };

  const handleScheduleFromWaitlist = (patient) => {
    console.log('Schedule from waitlist:', patient);
    setModalMode('create');
    setIsModalOpen(true);
  };

  return (
    <div className="flex h-screen bg-background overflow-hidden pt-16">
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <CalendarHeader
          currentDate={currentDate}
          viewMode={viewMode}
          onViewModeChange={setViewMode}
          onNavigate={handleNavigate}
          onTodayClick={handleTodayClick} />


        <FilterPanel
          filters={filters}
          onFilterChange={handleFilterChange}
          providers={providers}
          locations={locations}
          appointmentTypes={appointmentTypes} />


        <div className="flex-1 overflow-auto">
          <div className="hidden lg:block">
            {viewMode === 'day' &&
            <DayView
              date={currentDate}
              appointments={mockAppointments}
              providers={providers}
              onAppointmentClick={handleAppointmentClick}
              onSlotClick={handleSlotClick} />

            }
            {viewMode === 'week' &&
            <WeekView
              startDate={currentDate}
              appointments={mockAppointments}
              onAppointmentClick={handleAppointmentClick}
              onSlotClick={handleSlotClick} />

            }
            {viewMode === 'month' &&
            <MonthView
              currentDate={currentDate}
              appointments={mockAppointments}
              onDateClick={handleDateClick}
              onAppointmentClick={handleAppointmentClick} />

            }
          </div>

          <MobileAppointmentList
            appointments={mockAppointments}
            onAppointmentClick={handleAppointmentClick} />

        </div>

        {filters?.showWaitlist &&
        <WaitlistPanel
          waitlistPatients={waitlistPatients}
          onScheduleFromWaitlist={handleScheduleFromWaitlist} />

        }
      </div>
      <QuickActions actions={quickActions} position="bottom-right" />
      <AppointmentModal
        appointment={selectedAppointment}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSave={handleSaveAppointment}
        providers={providers}
        appointmentTypes={appointmentTypes}
        mode={modalMode} />

    </div>);

};

export default AppointmentScheduling;